export enum TriggerSpaceScopeEnum {
  ROOT_SPACE = 0,
  TRIGGERING_SPACE,
  ROOT_SPACE_AND_TRIGGERING_SPACE,
  ALL_SPACES_EXCEPT_ROOT,
  ALL_SPACES,
}
